import React from "react";
import socketio from "socket.io-client";
import Helper from "../Helper";
export const socket = socketio.connect(Helper.SocketBackendURL());

export const SocketContext = React.createContext();
